import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {stopJobAsyncAction} from '../../../../store/data/jobs/jobsActions';
import {getSelectAllJobs} from '../../../../store/data/jobs/jobsSelectors';
import {SelectAllBanners} from './selectAllBanners';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  jobs: getSelectAllJobs,
}));

export const SelectAllBannersContainer = connect(mapStateToProps, {
  onStopClick: (jobId: number) => stopJobAsyncAction(jobId),
})(SelectAllBanners);
